"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializePolyfills = void 0;

var initializePolyfills = function initializePolyfills() {
  if (typeof window !== 'undefined' && typeof window.CustomEvent !== 'function') {
    require('@insided/deprecated-utils/customEventPolyfill');
  }

  if (typeof window !== 'undefined' && !window._babelPolyfill) {
    require('@babel/polyfill');
  }

  if (typeof NodeList !== 'undefined' && typeof NodeList.prototype.forEach !== 'function') {
    require('@insided/deprecated-utils/forEachPolyfill').default();
  }
};

exports.initializePolyfills = initializePolyfills;